import API from "./api";

// 🔥 GET EXPENSES
export const getExpenses = (params) => {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  return API.get("/school-admin/expense/list/", {
    params, // 🔥 VERY IMPORTANT
    headers: {
      "X-SCHOOL-ID": school.school.id,
    },
  });
};

// 🔥 ADD EXPENSE
export const addExpense = async (data) => {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  return API.post("/school-admin/expense/add/", data, {
    headers: {
      "X-SCHOOL-ID": school.school.id,
    },
  });
};

// 🔥 DELETE EXPENSE
export const deleteExpense = async (id) => {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  return API.delete(`/school-admin/expense/delete/${id}/`, {
    headers: {
      "X-SCHOOL-ID": school.school.id,
    },
  });
};